import { BaseLoadingContainer } from '../masterBase/styles';

// Using base component for loading modal
export const LoadingMaster = BaseLoadingContainer;

